import { render, staticRenderFns } from "./DashboardSalesTargetChart.vue?vue&type=template&id=d220bf9c&"
import script from "./DashboardSalesTargetChart.vue?vue&type=script&lang=js&"
export * from "./DashboardSalesTargetChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports